module.exports = __webpack_public_path__ + "static/media/evangelist.e7c9918d.png";